/**
 * Easter egg: Animation de célébration quand un devis est signé
 * Pluie de 💰 + Toast notification
 *
 * Utilise le NotificationsContext (plus de canal Realtime dédié).
 */

import { useEffect, useState } from "react";
import { useNotificationsContext } from "@/lib/NotificationsContext";

interface SignatureEvent {
  caseId: string;
  companyName: string;
  quoteVersion: number;
}

export function SignatureCelebration() {
  const [celebration, setCelebration] = useState<SignatureEvent | null>(null);
  const [moneyEmojis, setMoneyEmojis] = useState<
    Array<{ id: number; left: number; delay: number }>
  >([]);
  const { onSignature } = useNotificationsContext();

  useEffect(() => {
    return onSignature((notification) => {
      const metadata = notification.metadata || {};
      const displayName =
        metadata.company_name || metadata.case_title || "Un client";

      setCelebration({
        caseId: notification.case_id ?? "",
        companyName: displayName,
        quoteVersion: metadata.quote_version || 1,
      });

      const emojis = Array.from({ length: 25 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
      }));
      setMoneyEmojis(emojis);

      setTimeout(() => {
        setCelebration(null);
        setMoneyEmojis([]);
      }, 4000);
    });
  }, [onSignature]);

  if (!celebration) return null;

  return (
    <>
      {/* Toast notification */}
      <div className="fixed top-4 right-4 z-[9999] animate-slide-in-right">
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-4 rounded-lg shadow-2xl border-2 border-green-400 max-w-md">
          <div className="flex items-start gap-3">
            <div className="text-3xl">🎉</div>
            <div>
              <div className="font-bold text-lg mb-1">Devis signé !</div>
              <div className="text-sm text-green-50">
                <strong>{celebration.companyName}</strong> a signé le devis v
                {celebration.quoteVersion}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pluie d'emojis 💰 */}
      <div className="fixed inset-0 pointer-events-none z-[9998] overflow-hidden">
        {moneyEmojis.map((emoji) => (
          <div
            key={emoji.id}
            className="absolute text-4xl animate-fall-down"
            style={{
              left: `${emoji.left}%`,
              top: "-50px",
              animationDelay: `${emoji.delay}s`,
            }}
          >
            💰
          </div>
        ))}
      </div>
    </>
  );
}
